import { render, staticRenderFns } from "./LogoBgMenu.vue?vue&type=template&id=5c108742&scoped=true&"
import script from "./LogoBgMenu.vue?vue&type=script&lang=js&"
export * from "./LogoBgMenu.vue?vue&type=script&lang=js&"
import style0 from "./LogoBgMenu.vue?vue&type=style&index=0&id=5c108742&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c108742",
  null
  
)

export default component.exports